import { useEffect } from 'react';
import { useCookieConsent } from './useCookieConsent';
import { grantAdConsent } from './googleAds';

/**
 * Bridges the cookie-consent state machine to Google Consent Mode.
 *
 * initGoogleAdsConsentMode() (called at app boot) handles the case where the
 * visitor had ALREADY accepted. This component handles the live case: the
 * visitor clicks "Accept all" in the CookieBanner during this session →
 * `allows('marketing')` flips true → we promote ad consent to granted so the
 * tag can fire without a reload.
 *
 * Renders nothing. Mount once at each app root (marketing RootLayout; portal
 * App root — above the router so the public /pay route is covered).
 */
export function GoogleAdsConsentBridge() {
  const { allows } = useCookieConsent();
  useEffect(() => {
    if (allows('marketing')) grantAdConsent();
  }, [allows]);
  return null;
}
